import { render, staticRenderFns } from "./EditMarqueeList.vue?vue&type=template&id=9a739472&scoped=true&"
import script from "./EditMarqueeList.vue?vue&type=script&lang=js&"
export * from "./EditMarqueeList.vue?vue&type=script&lang=js&"
import style0 from "./EditMarqueeList.vue?vue&type=style&index=0&id=9a739472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a739472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a739472')) {
      api.createRecord('9a739472', component.options)
    } else {
      api.reload('9a739472', component.options)
    }
    module.hot.accept("./EditMarqueeList.vue?vue&type=template&id=9a739472&scoped=true&", function () {
      api.rerender('9a739472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/utube/EditMarqueeList.vue"
export default component.exports